<template>
  <div class="bg" v-show="show">
    <div class="wrapper">
      <img src="@assets/img/interview/close.svg" alt="close" class="close" @click="cancel()">
      <p class="msg">
        <span>
          {{msg.title}}
        </span>
      </p>
      <p class="msgList">
        <i @click="isSelected=!isSelected" :class="{on: isSelected}" v-show="msg.status&&msg.isCg"></i>
        <span v-show="msg.isCg">{{msg.msg}}</span>
      </p>
      <div class="btns">
        <p class="confirm green" @click="confirm()">确认</p>
        <p class="cancel" @click="cancel()">取消</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'confirm',
  data() {
    return {
      show: true,
      msg: '',
      r: null,
      isSelected: false
    }
  },
  methods: {
    open(m, r) {
      this.msg = m
      if(this.msg.status){
        this.msg.status = true
      }else{
        this.msg.status = false
      }
      if(this.msg.isCg){
        this.msg.isCg = true
      }else{
        this.msg.isCg = false
      }
      this.r = r
      this.show = true
    },
    close() {
      this.show = false
    },
    confirm() {
      this.r({
        status: true,
        isSelected: this.isSelected
      })
      this.close()
    },
    cancel() {
      this.r({
        status: false,
        isSelected: this.isSelected
      })
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1222;
  }
  .wrapper {
    min-height: 240px;
    width: 400px;
    background-color: @bg;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    z-index: 99998;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    .close {
      position: absolute;
      right: 28px;
      top: 18px;
      cursor: pointer;
    }
    .msg {
      width: 80%;
      padding: 10px 20px;
      line-height: 26px;
      color: @dark;
      font-size: 20px;
      min-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin:0 auto 14px;
      word-break: break-all;
    }
    .msgList {
      width: 100%;
      padding: 10px 20px;
      line-height: 18px;
      color: #829191;
      font-size: 14px;
      min-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
      margin:0 auto 32px;
      word-break: break-all;

      i {
        position: relative;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid @green;
        box-sizing: border-box;
        margin-right: 10px;
        user-select: none;
        cursor: pointer;

        &.on {
          &::after {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-top: -5px;
            margin-left: -5px;
            display: block;
            content: '';
            width: 10px;
            height: 10px;
            background: @green;
            border-radius: 50%;
          }
        }
      }

      span {
        font-weight: bold;
      }
    }
    .btns {
      height: 40px;
      align-items: center;
      display: flex;
      justify-content: center;
    }
    .confirm, .cancel {
      background-color: @bg;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 100px;
      border: 1px solid @green;
      color: @green;
      font-size: 14px;
      // box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .green {
      margin-right: 20px;
      color: #fff;
      background-color: @green;
    }
  }
</style>
